import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import AssignmentSectionList from './AssignmentSectionList';

import { StudentAssignment } from '@ts-core/modules/assignments/types';

interface StudentAssignmentsListProps {
  nextAssignments?: StudentAssignment[];
  pastAssignments?: StudentAssignment[];

  onSelectAssignment?: (assignment: StudentAssignment) => void;

  emptyMessage?: React.ReactNode;
  loading?: boolean;
}

const StudentAssignmentsList = (props: StudentAssignmentsListProps) => {
  const intl = useIntl();

  const {
    loading,
    nextAssignments,
    pastAssignments,
    onSelectAssignment,
    emptyMessage = intl.formatMessage({ id: 'assignments.emptyMessage' }),
  } = props;

  if (!nextAssignments?.length && !pastAssignments?.length && !loading) {
    return <Box>{emptyMessage}</Box>;
  }

  return (
    <Box>
      {!!nextAssignments?.length && (
        <AssignmentSectionList
          assignments={nextAssignments}
          title={intl.formatMessage({ id: 'studentAssignments.nextAssignments' })}
          onSelectAssignment={onSelectAssignment}
        />
      )}

      {!!pastAssignments?.length && (
        <AssignmentSectionList
          assignments={pastAssignments}
          title={intl.formatMessage({ id: 'studentAssignments.pastAssignments' })}
          onSelectAssignment={onSelectAssignment}
        />
      )}
    </Box>
  );
};

StudentAssignmentsList.propTypes = {
  loading: PropTypes.bool,
  nextAssignments: PropTypes.array.isRequired,
  pastAssignments: PropTypes.array.isRequired,
  disableDoAssignment: PropTypes.bool,

  onSelectAssignment: PropTypes.func.isRequired,
};

StudentAssignmentsList.defaultProps = {
  loading: false,
  disableDoAssignment: false,
};

export default StudentAssignmentsList;
